<template>
  <div>
    <h3 class="mt-3 mb-4 title primary--text">
      {{ $t('Supervisions') }}
    </h3>
    <v-row class="white">
      <v-col>
        <div class="d-flex align-center">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            single-line
            hide-details
          />
          <v-btn
            class="ml-4"
            color="secondary"
            @click="exportTable"
          >
            {{ $t('export') }}
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="supervisionsFiltered"
          :search="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :group-by.sync="groupBy"
        >
          <template v-slot:header.laboratory.name="{header}">
            {{ header.text }}
            <span
              class="mx-3"
              @click="groupBy = header.value"
            >
              {{ $t('Group') }}
            </span>
          </template>

          <template v-slot:header.type="{header}">
            {{ header.text }}
            <span
              class="mx-3"
              @click="groupBy = header.value"
            >
              {{ $t('Group') }}
            </span>
          </template>

          <template
            v-slot:group.header="{group, groupBy, headers, isOpen, toggle, remove, items}"
          >
            <td
              :colspan="headers.length"
              class="text-start"
            >
              <div class="d-flex">
                <div>
                  <v-btn
                    icon
                    small
                    @click="toggle"
                  >
                    <v-icon v-if="isOpen">
                      mdi-minus
                    </v-icon>
                    <v-icon v-else>
                      mdi-plus
                    </v-icon>
                  </v-btn>

                  {{ groupByNameMapper[groupBy] }}: {{ group }}
                  <v-btn
                    icon
                    small
                    @click="remove"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div
                  v-if="groupBy == 'laboratory.name'"
                  class="ml-auto"
                >
                  <v-btn
                    icon
                    :to="{name: 'SupervisionList', params: {laboratoryId: items[0].laboratory.id}}"
                    target="_blank"
                  >
                    <v-icon
                      small
                    >
                      mdi-open-in-new
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
          </template>

          <template v-slot:item.createdAt="{ item }">
            <DateFormatter
              :unix-time="item.createdAt"
            />
          </template>

          <template v-slot:item.recommendations="{ item }">
            <div
              v-if="item.generatedRecommendationDataForShow"
              class="d-flex align-center"
            >
              {{ item.generatedRecommendationDataForShow.closed }} /
              {{ item.generatedRecommendationDataForShow.notClosed }} /
              {{ item.generatedRecommendationDataForShow.total }}
              <v-sheet
                v-if="item.generatedRecommendationDataForShow.recommendationEOD"
                class="rounded-circle d-inline-block ml-2 error"
                height="15"
                width="15"
              />
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              :to="{name: 'Supervision',params: {laboratoryId: item.laboratory.id,supervisionId: item.id}}"
              target="_blank"
            >
              <v-icon
                small
              >
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import DateFormatter from "@/components/atoms/DateFormatter";
import moment from 'moment';
import {
  export_json_to_excel_custom
} from '@/vendor/Export2Excel'

export default {
  name: "ReqToolSupervision",

  components: {
    DateFormatter,
  },

  props: {
    supervisions: {
      type: Array,
      required: true,
    },
    dateRange: {
      type: Array,
      required: true,
    }
  },

  data: () => {
    return {
      search: '',
      sortDesc: false,
      sortBy: 'laboratory',
      groupByNameMapper: {
        'laboratory.name': 'Laboratory Name',
        'type': 'Supervision Type'
      },
      groupBy: []
    }
  },

  computed: {
    headers() {
      let headers = [
        {
          text: this.$t('Laboratory'),
          value: 'laboratory.name',
          align: 'start',
          sortable: true,
          groupable: true,
        },
        {
          text: this.$t('Name'),
          value: 'name',
          align: 'start',
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t('Type'),
          value: 'type',
          align: 'start',
          sortable: true,
          groupable: true,
        },
        {
          text: this.$t('Language'),
          value: 'language',
          align: 'start',
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t('Score'),
          value: 'score',
          align: 'start',
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t('CreatedAt'),
          value: 'createdAt',
          align: 'start',
          sortable: true,
          groupable: false,
        },
        {
          text: this.$t('Recommendations') + ' \n ' + this.$t('(closed/not closed/all)'),
          value: 'recommendations',
          align: 'start',
          sortable: true,
          class: 'pre-line',
          groupable: false,
        },
        {
          text: this.$t('Actions'),
          value: 'actions',
          align: 'end',
          sortable: false,
          groupable: false,
        },
      ];

      return headers
    },

    supervisionsFiltered() {
      if (this.dateRange.length) {
        return this.supervisions.filter(supervision => moment(supervision.createdAt).isBetween(this.dateRange[0], this.dateRange[1]), undefined, '[]')
      }


      return this.supervisions
    }
  },

  methods: {
    exportTable() {
      let multiData = [];

      {
        const tHeader = [
          '#', 'Laboratory', 'Name', 'Type', 'Language', 'Score', 'CreatedAt', 'Recommendations (closed/not closed/all)'
        ];


        const filterVal = [
          '#', 'laboratory', 'name', 'type', 'language', 'score', 'createdAt', 'recommendations'
        ];

        const deepValues = {
          laboratory(item) {
            return item?.laboratory?.name || ''
          },
          recommendations(item) {
            if (!item?.generatedRecommendationDataForShow) return '';
            return `${item.generatedRecommendationDataForShow.closed} / ${item.generatedRecommendationDataForShow.notClosed} / ${item.generatedRecommendationDataForShow.total}`
          },
          createdAt(item) {
            return moment(item.createdAt).format('YYYY/MM/DD')
          }
        };


        let data = this.supervisionsFiltered.map((v, index) => {
          return filterVal.map(j => {
            if (j === '#') return index + 1;
            if (v[j]) {
              if (j in deepValues) {
                return deepValues[j](v)
              } else {
                return v[j].toString()
              }
            }

            return ''
          });
        }).filter(e => e);

        multiData.push({name: 'Supervision', header: tHeader, data})
      }

      export_json_to_excel_custom({
        multiData,
        filename: 'supervision',
        autoWidth: true,
      })

    }
  }
}
</script>

<style scoped>

</style>
